const state = {
  formKanban: {
  },
  selectedCode: '',
  actualLoop: 'loop_external',
  changeOnlyLogistic: false
};

const getters = {
  getFormKanban: () => state.formKanban,
  selectedCode: () => state.selectedCode,
  changeOnlyLogistic: () => state.changeOnlyLogistic,
  actualLoop: () => state.actualLoop
};

const actions = {

};

const mutations = {
  setSelectedCode: (state, code) => state.selectedCode = code,
  resetKanbanForm: (state, code) => {
    state.formKanban = {is_in_db: false, is_in_sage: false, code:state.selectedCode}
  },
  updateKanbanForm: (state, form) => {
    state.formKanban = {...state.form, ...form, code:state.selectedCode}
  },
  setChangeOnlyLogistic: (state, changeOnlyLogistic) => state.changeOnlyLogistic = changeOnlyLogistic,
  setActualLoop: (state, actualLoop) => state.actualLoop = actualLoop

};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/kanban.js